import { action, computed, makeObservable, observable } from 'mobx';
import { throttle } from '@datum-map/utils/throttle';
import { MapStore } from '@project/store/Map';
import { UserActivityValue, UserTrigger } from '@datum-map/types';
import { UserActivityFeature } from '@datum-group/datum-map/lib/types';

export class FeatureTooltipController {
  @observable private _features?: UserActivityFeature[] = undefined;
  @observable private _coordinate?: number[] = undefined;

  constructor(private _map: MapStore) {
    makeObservable<FeatureTooltipController>(this);
  }

  @computed get features() {
    return this._features;
  }

  @computed get coordinate() {
    return this._coordinate;
  }

  @action processEvent(data: UserActivityValue) {
    this._features = data.features;
    this._coordinate = data.coordinate;
  }

  private _throttledHandler = throttle(
    (evt: UserActivityValue) => this.processEvent(evt),
    100,
  );

  bind = () => {
    this._map.userActivityManager.subscribe(
      this._throttledHandler,
      UserTrigger.HOVER,
    );
  };

  unbind = () => {
    this._map.userActivityManager.unsubscribe(
      this._throttledHandler,
      UserTrigger.HOVER,
    );
  };
}
